import * as React from 'react';
import { timeAgo } from './util';

export const WorkflowLastUpdated = (updatedAt: string) => {
  if (!updatedAt) return;
  return timeAgo(new Date(updatedAt));
};
